export default __webpack_public_path__ + "static/media/obrien.4a739215.jpeg";